// extracted by mini-css-extract-plugin
export default {"productsFilter":"productsFilter_productsFilter__Smx9Y","productsFilterActive":"productsFilter_productsFilterActive__sblzw"};